import { render } from "./BackHeader.vue?vue&type=template&id=7d2756ea"
import script from "./BackHeader.vue?vue&type=script&lang=js"
export * from "./BackHeader.vue?vue&type=script&lang=js"

import "./BackHeader.vue?vue&type=style&index=0&id=7d2756ea&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__